import { useState } from 'react'
import './styles/accordion-item.css'

export default function AccordionItem({item}) {
    const [open,setOpen] = useState(false)

    const accordionHandler = () => {
        setOpen((state) => !state)
    }

  return (
   <>
    <button onClick={accordionHandler} className='accordion-item'>
        <div className='accordion-item-icon'>
            {
                open
                ?
                <div className='accordion-item__minus'></div>
                :
                <div className='accordion-item__plus'>
                    <span></span>
                    <span></span>
                </div>
            }
        </div>
        <div className='accordion-item__title'>
            {item.title}
        </div>
    </button>
    {
        <div className={open ? 'accordion-item-body open' : 'accordion-item-body'}>
            {item.body}
        </div>
    }
   </>
  )
}
